import { Briefcase, Check, ChevronDown, Eye } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { trpc } from '../lib/trpc';
import { getActiveWorkspace, setActiveWorkspace } from '../lib/workspace';

// Selector de espacio de trabajo (M7, equipos). Solo se muestra si el
// usuario pertenece a algún espacio ajeno.
export function WorkspaceSwitcher() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { data: workspaces } = trpc.teams.myWorkspaces.useQuery();
  const active = getActiveWorkspace();

  if (!workspaces?.length && !active) return null;

  const label = active ? active.ownerName : t('Mi espacio');

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`flex h-10 items-center gap-2 rounded-xl border px-2.5 text-sm font-medium transition sm:px-3 ${
          active
            ? 'border-warning/25 bg-warning/10 text-warning hover:bg-warning/15'
            : 'border-border bg-card/60 text-muted-foreground hover:border-primary/30 hover:bg-accent hover:text-foreground'
        }`}
        title={t('Cambiar de espacio de trabajo')}
      >
        <Briefcase className="h-4 w-4" />
        <span className="hidden max-w-[140px] truncate lg:inline">{label}</span>
        {active?.role === 'VIEWER' && <Eye className="h-3.5 w-3.5" />}
        <ChevronDown className="h-3.5 w-3.5" />
      </button>

      {open && (
        <div className="absolute right-0 z-20 mt-2 w-64 rounded-2xl border border-border bg-popover p-2 text-popover-foreground shadow-2xl">
          <button
            className="flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-left text-sm text-muted-foreground transition hover:bg-accent hover:text-foreground"
            onClick={() => {
              setOpen(false);
              if (active) setActiveWorkspace(null);
            }}
          >
            {!active && <Check className="h-4 w-4 text-success" />}
            <span className={active ? 'ml-6' : ''}>{t('Mi espacio')}</span>
          </button>
          {(workspaces ?? []).map(ws => {
            const isActive = active?.ownerId === ws.ownerId;
            return (
              <button
                key={ws.ownerId}
                className="flex w-full items-center gap-2 rounded-xl px-3 py-2.5 text-left text-sm text-muted-foreground transition hover:bg-accent hover:text-foreground"
                onClick={() => {
                  setOpen(false);
                  if (!isActive) {
                    setActiveWorkspace({
                      ownerId: ws.ownerId,
                      ownerName: ws.ownerName,
                      role: ws.role,
                    });
                  }
                }}
              >
                {isActive && <Check className="h-4 w-4 text-success" />}
                <span className={`truncate ${isActive ? '' : 'ml-6'}`}>
                  {ws.ownerName}
                </span>
                <span className="ml-auto text-xs text-muted-foreground">
                  {ws.role === 'VIEWER' ? t('lector') : t('editor')}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
